import React from 'react';
import Lightbox from 'react-lightbox-component';
import '../../styles/project-page.scss';
const spaincasino = require('../../assets/spaincasino.jpg');
const spaincasinomob = require('../../assets/spaincasinomob.png');
const spainvipdesktop = require('../../assets/SpainVIPDesktop.png');
const spainvipmobile = require('../../assets/SpainVIPMobile.png');

const shinrahome = require('../../assets/shinrahome.gif');
const shinrascanprocess = require('../../assets/shinrascanprocess.gif');
const mupdevicelist = require('../../assets/mupdevicelist.png');
const mupreport = require('../../assets/mupreport.png');
const mupstorage = require('../../assets/mupstorage.png');
const mupfamily = require('../../assets/mupfamily.png');

export class ProjectPage extends React.Component {

  render() {
    return (
      <div className="pagecontent">
        <h2>Projects</h2>
        <ul>
          <li>
            <h3>William Hill</h3>
            <h5>International Casino</h5>
            <p>The flagship gaming product for the International (Spanish and Italian) environments in William Hill is the Casino product - the lobby provides access to games supplied by the 3rd party company Playtech, and does so in a way that complies with all the necessary local gambling regulations for the region it's available in.</p>
            <p>The lobby is based on a pre-existing componentised AngularJS framework, modified and adapted to provide a new design, various new user-facing features and facilities to meet legal requirements. To ensure as much development efficiency as possible, the Spanish and Italian lobbies use the same codebase, using separate configuration options to customise, or even switch on and off completely, the required features in each region. Many of the components used are also included in the various sites supporting the Casino lobbies, such as promotional sites and VIP sites.</p>
            <p>The sites can be seen in action at <a href="https://casino.williamhill.es">casino.williamhill.es</a> and <a href="https://casino.williamhill.it">casino.williamhill.it</a></p>
            <Lightbox thumbnailWidth='100px' thumbnailHeight='100px' images={[
              {
                src: spaincasino,
                title: 'William Hill Online Casino (Spain)',
                description: 'Visit at casino.williamhill.es or casino.williamhill.it'
              },
              {
                src: spaincasinomob,
                title: 'William Hill Online Casino (Spain)',
                description: 'Visit at casino.williamhill.es or casino.williamhill.it'
              },
              {
                src: spainvipdesktop,
                title: 'William Hill VIP (Spain)',
                description: 'The VIP portal for Spain allows select customers to track their daily reward points'
              },
              {
                src: spainvipmobile,
                title: 'William Hill VIP (Spain) Mobile',
                description: 'It\'s designed to be fully responsive'
              }
            ]}/>
          </li>
          <li>
            <h3>Trend Micro</h3>
            <h5>Online Storage Scanner</h5>
            <p>Online Storage Scanner was a feature added to Trend Micro’s flagship security products allowing users to scan, quarantine and manage their online storage to protect against common malware as they would do with local files on their physical devices.</p>
            <p>It was built on Backbone and used React to render JSX templates. Communication with the cloud based scan engine, for the purposes of monitoring scan progress, was managed via a websocket connection where available, falling back to a simple AJAX poll elsewhere.</p>
            <h5>Tellus</h5>
            <p>Tellus was Trend Micro’s online security report portal, developed to integrate with and aggregate data from security software installed on multiple devices protecting multiple users. Built on Backbone.js and using React to render JSX templates, the web portal displayed a variety of data collected from the user’s devices, including details of infected files found, average and total startup times and disk space recovered, all displayed in a visually pleasing way using a combination of simple HTML and CSS based charts and more complex data visualizations created with Raphael.js.</p>
            <p>Tellus also featured an email report component, displaying much of the same data in a static format sent to the user on a regular basis. Although email compatible HTML and CSS is very limited in it’s capabilities compared to that which can be used in modern browsers, and the number and variety of clients with different levels of support is great, we were able to implement templates that rendered accurate charts and other data visualizations across a large number of the most common desktop email clients and webmail services.</p>
            <Lightbox thumbnailWidth='100px' thumbnailHeight='100px' images={[
              {
                src: shinrahome,
                title: 'Online Storage Scanner Home',
                description: 'Online Storage Scanner Home'
              },
              {
                src: shinrascanprocess,
                title: 'Online Storage Scanner Progress',
                description: 'Online Storage Scanner Progress'
              },
              {
                src: mupdevicelist,
                title: 'Tellus Device List',
                description: 'The device list UI for the Tellus product'
              },
              {
                src: mupreport,
                title: 'Tellus Report',
                description: 'Tellus reports used simple HTML combined with some advanced CSS to achieve high levels of compatibility while still looking great'
              },
              {
                src: mupstorage,
                title: 'Tellus Report',
                description: 'More advanced reports used Raphael.js to create complex animated charts'
              },
              {
                src: mupfamily,
                title: 'Tellus Multi-user UI',
                description: 'The well designed multi-user UI allowed a large number of devices to be administered in a single, simple page'
              }
            ]}/>
          </li>
        </ul>
      </div>
    );
  }
}

export default ProjectPage
